// useFileUpload.ts
import { useState } from "react";
import { uploadFilesService } from "../services/uploadService";
import { UploadFile } from "antd/es/upload/interface";

export const useFileUpload = (cotaUsuarioId: number | undefined | null) => {
  const [fileList, setFileList] = useState<UploadFile[]>([]);
  const [uploading, setUploading] = useState(false);
  const [uploadedFiles, setUploadedFiles] = useState<UploadFile[]>([]);
  const [error, setError] = useState<string | null>(null);
  const [success, setSuccess] = useState<string | null>(null);

  const resetError = () => setError(null);
  const resetSuccess = () => setSuccess(null);

  const handleRemove = (file: UploadFile) => {
    const index = fileList.indexOf(file);
    const newFileList = fileList.slice();
    newFileList.splice(index, 1);
    setFileList(newFileList);
  };

  const beforeUpload = (file: UploadFile) => {
    setFileList([...fileList, file]);
    return false; // Previne o upload automático
  };

  const handleUpload = async () => {
    if (!cotaUsuarioId) return; // Verificar se o cotaUsuarioId está disponível

    setUploading(true);

    try {
      const responses = await uploadFilesService(fileList, cotaUsuarioId);
      setUploadedFiles(fileList);
      setUploading(false);
      setSuccess("O arquivo foi enviado com sucesso!");
      return responses;
      // Processar respostas do backend se necessário
    } catch (error) {
      setUploading(false);
      setError("Não foi possível enviar arquivo!");
      console.error("Erro ao fazer upload", error);
      return false;
    }
  };

  return {
    fileList,
    uploading,
    uploadedFiles,
    handleRemove,
    beforeUpload,
    handleUpload,
    error,
    success,
    resetError,
    resetSuccess,
  };
};
